import React from "react";

export const SessionExpiredBox : React.FC = () => {
    return(
        <>
            Sessione scaduta
        </>
    );
}